exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".active-calls .toolbar {\n  display: flex;\n  justify-content: space-between; }\n  .active-calls .toolbar .filter {\n    flex: 1;\n    margin-right: 50px; }\n  .active-calls .toolbar .activeCallList-filter {\n    width: 100%; }\n\n.active-calls .call {\n  box-shadow: 0 2px 2px #ccc;\n  border: 1px solid #ccc;\n  margin: 1rem 0;\n  padding: 1rem; }\n  .active-calls .call .subscribers {\n    display: flex;\n    border-bottom: 1px solid #ccc; }\n    .active-calls .call .subscribers .subscriber {\n      flex: 1; }\n  .active-calls .call .call-info {\n    margin: 0.5rem 0; }\n  .active-calls .call .action-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center; }\n    .active-calls .call .action-row button {\n      border: 0;\n      border-radius: 0; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/sass-loader/lib/loader.js!./styles/active-calls.scss
// module id = 548
// module chunks = 0